// extracted by mini-css-extract-plugin
export default {"header":"HeaderSection_header__05dW6","heading":"HeaderSection_heading__Lpl2s"};